<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Подписка PRO будет отменена"
      @button-click="onConfirm"
      @secondary-button-click="onDetails"
      @hidden="emit('hidden')"
      button-text="Оставить PRO"
      secondary-button-text="Подробнее"
      :max-width="450"
  >

    <template #default>
        <p class="pro-expiring-modal__text mb-3">
            <template v-if="paymentFailed">
                Не удалось списать средства за подписку, вы будете переведены на бесплатный тариф {{ formatDate(proExpiresAt) }}
            </template>
            <template v-else>
                У вас заканчивается подписка PRO {{ formatDate(proExpiresAt) }}
            </template>
        </p>
        <p class="pro-expiring-modal__text mb-3">
            После этого:
            <ul class="pro-expiring-modal__list">
                <li>доступ ко всем функциям отключится, ученики сверх лимита будут автоматически перемещены в архив</li>
                <li>станет доступна новая система тарифов с оплатой отдельных опций</li>
            </ul>
        </p>
        <p class="pro-expiring-modal__text">
            Вы сможете подключить только нужные функции в любой момент
        </p>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

defineProps<{
    proExpiresAt: string;
    paymentFailed: boolean;
}>();
function onConfirm() {
    emit('confirm');
    hideModal();
}

function onDetails() {
    emit('details');
    hideModal();
}

const emit = defineEmits<{
    (e: 'hidden'): void;
    (e: 'confirm'): void;
    (e: 'details'): void;
}>();


function formatDate(dateString: string) {
    const date: Date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});

</script>

<style lang="scss" scoped>
// Стили для конкретного тарифного модала (размеры картинки, отступы, кнопка)
.pro-expiring-modal__image {
    width: 267px;
    height: 203px;
    object-fit: cover;
    display: block;

    @media (max-width: 767.98px) {
        width: 165px;
        height: 126px;
        margin: 0 auto 10px; // центрирование + отступ снизу
    }
}

.pro-expiring-modal__text {
    font-size: 14px;
}

.pro-expiring-modal__footer {
    margin-top: 1rem;
    text-align: right;

    @media (max-width: 767.98px) {
        text-align: center;
    }
}
</style>